import { useEffect, useState } from 'react'
import { addDays, lightFormat } from 'date-fns'
import { useFindDeliveryInfoDateMutation } from 'modules/deliveryInfo/api'
import { DeliveryTypeEnum } from 'modules/deliveryInfo/types'
import { DeliveryDateResponse, TerminalItem } from 'schema'

type CreatePoint = {
  terminalId: string
}

interface UseDestinationDateProps {
  departurePoint?: RecursivePartial<TerminalItem & CreatePoint>
  destinationPoint?: RecursivePartial<TerminalItem & CreatePoint>
}

export const useYarcheDestinationDate = ({ departurePoint, destinationPoint }: UseDestinationDateProps) => {
  const [findDeliveryInfoDate, { data: deliveryDate, isLoading }] = useFindDeliveryInfoDateMutation()

  useEffect(() => {
    if (!departurePoint?.terminalId || !destinationPoint?.terminalId) {
      return
    }

    findDeliveryInfoDate({
      departureDate: lightFormat(addDays(new Date(), 1), 'yyyy-MM-dd'),
      departureTerminalId: departurePoint.terminalId,
      destinationTerminalId: destinationPoint.terminalId,
      type: DeliveryTypeEnum.terminal
    })
  }, [departurePoint, destinationPoint, findDeliveryInfoDate])

  return { deliveryDate, isLoading }
}
